import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Logo from "../../components/Logo";
import { useLocation } from "react-router-dom";
import LangChanger from "@layout/LangChanger";
import { LucideCircleUserRound } from "lucide-react";

const Header = ({ openModal }) => {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <main className="position-absolute w-100 top-0 start-0" style={{ zIndex: 10 }}>
  <div className="bg-transparent">
    <div className="container-xl py-4">




      <Row className="align-items-center justify-content-between">
        <Col xs="4" xl="3" className="text-white">
          <Logo isWhite={true} />
        </Col>

        <Col xs="7">
          <div className="d-flex justify-content-end align-items-center gap-4 fw-300"
               style={{ fontSize: "90%" }}>
            <span className="d-md-block text-white">
              <LangChanger location={location} t={t} />
            </span>

            <button
              className="d-none d-md-inline-block bg-blue text-white py-3 px-5 rounded-3 border border-white lh-1"
              onClick={() => openModal("in")}
            >
              {t('log_in')}
            </button>

            <button
              className="d-none d-md-inline-block bg-blue text-white bg-opacity-50 py-3 px-5 rounded-3 lh-1"
              onClick={() => openModal("up")}
            >
              {t('register')}
            </button>
              <button
                  className="d-inline-block d-md-none bg-transparent border-0 text-white fs-4"
                  onClick={() => openModal("in")}
                  aria-label="User menu"
                >
                  <LucideCircleUserRound size={23} />
                </button>
          </div>
        </Col>
      </Row>
    </div>
  </div>
</main>
  );
};

export default Header;
